import { PCM_WORKLET_SOURCE } from "./pcm-worklet";

export class AudioCapture {
    constructor({ ctx, onPcmChunk }) {
        this.ctx = ctx;
        this.onPcmChunk = onPcmChunk;
        this.stream = null;
        this.node = null;
        this.source = null;
    }

    async start() {
        const blob = new Blob([PCM_WORKLET_SOURCE], { type: "text/javascript" });
        const url = URL.createObjectURL(blob);
        try {
            await this.ctx.audioWorklet.addModule(url);
        } finally {
            URL.revokeObjectURL(url);
        }

        this.stream = await navigator.mediaDevices.getUserMedia({
            audio: {
                echoCancellation: true,
                noiseSuppression: true,
                autoGainControl: true,
                channelCount: 1
            }
        });

        this.source = this.ctx.createMediaStreamSource(this.stream);
        this.node = new AudioWorkletNode(this.ctx, "pcm-capture", {
            numberOfInputs: 1,
            numberOfOutputs: 0,
            channelCount: 1
        });

        this.node.port.onmessage = (e) => {
            const f32 = new Float32Array(e.data);
            const pcm16 = new Int16Array(f32.length);
            for (let i = 0; i < f32.length; i++) {
                const s = Math.max(-1, Math.min(1, f32[i]));
                pcm16[i] = s < 0 ? s * 0x8000 : s * 0x7fff;
            }
            this.onPcmChunk(pcm16);
        };

        this.source.connect(this.node);
    }

    async stop() {
        this.source?.disconnect();
        this.node?.disconnect();
        this.node = null;
        this.source = null;
        this.stream?.getTracks().forEach((t) => t.stop());
        this.stream = null;
    }

    get sampleRate() {
        return this.ctx.sampleRate;
    }
}

export function pcm16ToBase64(pcm16) {
    const bytes = new Uint8Array(pcm16.buffer, pcm16.byteOffset, pcm16.byteLength);
    let binary = "";
    const chunk = 0x8000;
    for (let i = 0; i < bytes.length; i += chunk) {
        binary += String.fromCharCode.apply(null, Array.from(bytes.subarray(i, i + chunk)));
    }
    return btoa(binary);
}
